import { ActionCreator } from 'react-redux'
import { ThunkAction } from 'redux-thunk'

import { setSeoMeta } from '../actions/common'
import axiosVerbose from '../utils/axios/axiosVerbose'
import { logError } from '../utils/errors'

import {
  IFeaturedAuthorResults,
  ISearchResults
} from '../../typings/searchResults'
import { ISeoMetadata } from '../../typings/seoMetadata'
import { ICommonLocation } from '../utils/location/types'

import { IRootState } from '../../common/reducers'

export enum TypeKeys {
  GET_HOME_PAGE_API_SUCCESS = 'GET_HOME_PAGE_API_SUCCESS',
  GET_HOME_PAGE_API_FAIL = 'GET_HOME_PAGE_API_FAIL'
}

export interface IHomePageApiData {
  readonly metadata?: ISeoMetadata
  readonly newest_items?: ISearchResults
  readonly featured_items?: ISearchResults
  readonly free_items?: ISearchResults
  readonly featured_author?: IFeaturedAuthorResults
}

export interface IGetHomePageApiSuccessAction {
  type: TypeKeys.GET_HOME_PAGE_API_SUCCESS
  payload: Readonly<IHomePageApiData>
}

export interface IGetHomePageApiFailAction {
  type: TypeKeys.GET_HOME_PAGE_API_FAIL
}

export type ActionTypes =
  | IGetHomePageApiSuccessAction
  | IGetHomePageApiFailAction

export const fetchHomePageDataBySite: ActionCreator<
  ThunkAction<Promise<ActionTypes>, IRootState, void>
> = (location: ICommonLocation, apiUrlPrefix: string) => {
  return (dispatch, getState) => {
    const { currentSite } = getState().common

    return axiosVerbose
      .get(`${apiUrlPrefix}/shopfront_api/homepage/${currentSite}`)
      .then(response => {
        const action: IGetHomePageApiSuccessAction = {
          payload: response.data,
          type: TypeKeys.GET_HOME_PAGE_API_SUCCESS
        }
        dispatch(setSeoMeta(response.data.metadata))
        return dispatch(action)
      })
      .catch(err => Promise.reject(logError(err)))
      .catch(() => {
        const action: IGetHomePageApiFailAction = {
          type: TypeKeys.GET_HOME_PAGE_API_FAIL
        }
        return dispatch(action)
      })
  }
}
